/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 急救箱日志列表 的 **请求配置**
 *
 * @分类 采购API
 * @请求头 `POST /erp/Log/getPlanCancelLogList`
 */
const postGetPlanCancelLogListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Log/getPlanCancelLogList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetPlanCancelLogList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 急救箱日志列表 的 **请求函数**
 *
 * @分类 采购API
 * @请求头 `POST /erp/Log/getPlanCancelLogList`
 */
export const postGetPlanCancelLogList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetPlanCancelLogListRequestConfig, requestData),
    ...args
  );
};
postGetPlanCancelLogList.requestConfig = postGetPlanCancelLogListRequestConfig;
/**
 * 接口 获取急救箱日志筛选项 的 **请求配置**
 *
 * @分类 采购API
 * @请求头 `POST /erp/Log/optionsForPlanCancelLogList`
 */
const postOptionsForPlanCancelLogListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Log/optionsForPlanCancelLogList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postOptionsForPlanCancelLogList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取急救箱日志筛选项 的 **请求函数**
 *
 * @分类 采购API
 * @请求头 `POST /erp/Log/optionsForPlanCancelLogList`
 */
export const postOptionsForPlanCancelLogList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postOptionsForPlanCancelLogListRequestConfig, requestData),
    ...args
  );
};
postOptionsForPlanCancelLogList.requestConfig =
  postOptionsForPlanCancelLogListRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 计划断货日志列表-筛选项 的 **请求配置**
 *
 * @分类 采购API/计划
 * @请求头 `POST /erp/Log/optionsForList`
 */
const postOptionsForListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/Log/optionsForList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postOptionsForList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 计划断货日志列表-筛选项 的 **请求函数**
 *
 * @分类 采购API/计划
 * @请求头 `POST /erp/Log/optionsForList`
 */
export const postOptionsForList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postOptionsForListRequestConfig, requestData),
    ...args
  );
};
postOptionsForList.requestConfig = postOptionsForListRequestConfig;
const mockUrl_0_0_0_2 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_2 = "";
const prodUrl_0_0_0_2 = "";
const dataKey_0_0_0_2 = "data";
/**
 * 接口 订单断货日志 的 **请求配置**
 *
 * @分类 旧接口文档/订单相关
 * @请求头 `POST /erp/Log/orderStopLogList`
 */
const postOrderStopLogListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Log/orderStopLogList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postOrderStopLogList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 订单断货日志 的 **请求函数**
 *
 * @分类 旧接口文档/订单相关
 * @请求头 `POST /erp/Log/orderStopLogList`
 */
export const postOrderStopLogList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postOrderStopLogListRequestConfig, requestData),
    ...args
  );
};
postOrderStopLogList.requestConfig = postOrderStopLogListRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/log.js